import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Body } from '../op-types';

export function createAuthQueries(client: StoxlyClient) {
  return createQueryKeys('auth', {
    // ['auth', 'me']
    me: {
      queryKey: null,
      queryFn: ({ signal }) => client.authGetMe({ signal }),
    },
  });
}

export function createAuthMutations(client: StoxlyClient) {
  return {
    logoutAll: {
      mutationFn: () => client.authLogoutAll(undefined),
    },
    // Register-form duplicate-email check against the local users table.
    checkEmailAvailability: {
      mutationFn: (body: Body<'authCheckEmailAvailability'>) =>
        client.authCheckEmailAvailability(body),
    },
  };
}
